import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MainNavItem, mainNavItems } from './mainNav';
import './MainNav.css';

const ICONS: Record<MainNavItem['key'], React.ReactNode> = {
  competitions: <path d="M5 21V4h11l-1.5 4L16 12H5" />,
  mine: <path d="M3 7h6l2 2h10v10H3z" />,
  admin: <path d="M12 3l8 4v5c0 5-3.5 8-8 9-4.5-1-8-4-8-9V7z" />,
  alerts: <path d="M6 16V11a6 6 0 1112 0v5l2 2H4zM10 20h4" />,
  profile: <path d="M12 12a4 4 0 100-8 4 4 0 000 8zM4 21a8 8 0 0116 0" />,
};

const Icon: React.FC<{ name: MainNavItem['key'] }> = ({ name }) => (
  <svg className="main-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{ICONS[name]}</svg>
);

export const DesktopNav: React.FC<{ isAdmin: boolean }> = ({ isAdmin }) => {
  const { pathname } = useLocation();
  return (
    <nav className="desktop-nav" aria-label="Main" data-tour="main-nav">
      {mainNavItems(isAdmin).filter((i) => i.desktop).map((item) => (
        <Link key={item.key} to={item.to} className="desktop-nav__link"
          aria-current={item.match(pathname) ? 'page' : undefined}>{item.label}</Link>
      ))}
    </nav>
  );
};

const BottomNav: React.FC<{ isAdmin: boolean; unreadCount: number }> = ({ isAdmin, unreadCount }) => {
  const { pathname } = useLocation();
  // CSS is bundled globally, so the page padding is scoped to pages that render this bar.
  useEffect(() => {
    document.body.classList.add('has-bottom-nav');
    return () => document.body.classList.remove('has-bottom-nav');
  }, []);
  return (
    <nav className="bottom-nav" aria-label="Main" data-tour="bottom-nav">
      {mainNavItems(isAdmin).filter((i) => i.phone).map((item) => (
        <Link key={item.key} to={item.to} className="bottom-nav__link"
          aria-current={item.match(pathname) ? 'page' : undefined}>
          <Icon name={item.key} />
          <span>{item.shortLabel}</span>
          {item.key === 'alerts' && unreadCount > 0 && (
            <span className="bottom-nav__badge">
              {unreadCount > 99 ? '99+' : unreadCount}
              <span className="sr-only"> unread</span>
            </span>
          )}
        </Link>
      ))}
    </nav>
  );
};

export default BottomNav;
